
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { HistoricalFact } from "@/components/unit-converter/HistoricalFact";
import { AdUnit } from "@/components/ads/AdUnit";

const Results = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { result, measurementType, fromUnit, toUnit } = location.state || { 
    result: null, 
    measurementType: "",
    fromUnit: "",
    toUnit: ""
  };

  if (!location.state || !result) {
    return <Navigate to="/" replace />;
  }

  const handleNewConversion = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-manuscript-background py-12">
      <div className="container">
        <header className="text-center mb-12">
          <h1 className="text-5xl font-cinzel text-manuscript-primary mb-4">
            {fromUnit} to {toUnit} Conversion
          </h1>
          <p className="text-manuscript-primary/70 max-w-2xl mx-auto">
            Historical unit conversion calculator for {measurementType} measurements
          </p>
        </header>

        <div className="w-full max-w-3xl mx-auto space-y-6">
          <div className="bg-white/50 backdrop-blur-sm rounded-lg shadow-lg p-8 border border-manuscript-secondary">
            <div className="text-center space-y-6">
              <h2 className="text-3xl font-cinzel text-manuscript-primary">Conversion Result</h2>
              <p className="text-xl font-medium text-manuscript-primary">{result}</p>
              
              <Button 
                onClick={handleNewConversion}
                className="mt-6 bg-manuscript-primary text-white hover:bg-manuscript-primary/90"
              >
                <RotateCcw className="mr-2 h-4 w-4" />
                Do Another Conversion
              </Button>
            </div>
          </div>
          
          <HistoricalFact 
            measurementType={measurementType} 
            fromUnit={fromUnit}
            toUnit={toUnit}
          />

          <div className="my-16 py-8">
            <AdUnit 
              adSlot="3043090605"
              className="min-h-[250px] w-full bg-gray-100/50 rounded-lg"
              desktopOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Results;
